import React, { useEffect, useContext }from "react";

// core components
import Button from "beaktShared/components/CustomButtons/Button.js";

//icons
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import StrikethroughSIcon from '@material-ui/icons/StrikethroughS';
import ClosedCaptionIcon from '@material-ui/icons/ClosedCaption';
import FormatTextdirectionLToRIcon from '@material-ui/icons/FormatTextdirectionLToR';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import CodeIcon from '@material-ui/icons/Code';
import AddIcon from '@material-ui/icons/Add';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import FormatAlignJustifyIcon from '@material-ui/icons/FormatAlignJustify';

import "assets/css/tiptap.css";

var styleMenu = {
  tipTapButton: {
    padding: "0.2rem 0.2rem !important",
    border: "1px solid #999999  !important"
  },  
}

export default function MenuBar({ editor }) {
  
  if (!editor) {
    return null
  }

  return (
      <div style={{borderBottom: "1px solid #ccc"}}>

        <Button color={editor.isActive('bold') ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().toggleBold().run()} >
          <FormatBoldIcon></FormatBoldIcon>
        </Button>
        <Button color={editor.isActive('italic') ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().toggleItalic().run()}>
          <FormatItalicIcon></FormatItalicIcon> 
        </Button>
        <Button color={editor.isActive('strike') ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().toggleStrike().run()} className={styleMenu.tipTapButton}>
          <StrikethroughSIcon></StrikethroughSIcon>
        </Button>
        <Button color={editor.isActive('code') ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().toggleCode().run()} className={styleMenu.tipTapButton}>
          <ClosedCaptionIcon></ClosedCaptionIcon>
        </Button>
        <Button color={editor.isActive('heading', { level: 1 }) ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()} className={styleMenu.tipTapButton}>
          h1
        </Button>
        <Button color={editor.isActive('heading', { level: 2 }) ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()} className={styleMenu.tipTapButton + " " + editor.isActive('heading', { level: 2 }) ? 'is-active' : ''}>
          h2
        </Button>
        <Button color={editor.isActive('heading', { level: 3 }) ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()} className={styleMenu.tipTapButton + " " + editor.isActive('heading', { level: 3 }) ? 'is-active' : ''}>
          h3
        </Button>
        <Button color={editor.isActive('heading', { level: 4 }) ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()} className={styleMenu.tipTapButton + " " + editor.isActive('heading', { level: 4 }) ? 'is-active' : ''}>
          h4
        </Button>
        <Button color={editor.isActive('heading', { level: 5 }) ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().toggleHeading({ level: 5 }).run()} className={styleMenu.tipTapButton + " " + editor.isActive('heading', { level: 5 }) ? 'is-active' : ''}>
          h5
        </Button>
        <Button color={editor.isActive('heading', { level: 6 }) ? "default" : "transparent"} onClick={() => editor.chain().focus().toggleHeading({ level: 6 }).run()} className={styleMenu.tipTapButton + " " + editor.isActive('heading', { level: 6 }) ? 'is-active' : ''}>
          h6
        </Button>
        <Button color={editor.isActive('bulletList') ? "default" : "transparent"} onClick={() => editor.chain().focus().toggleBulletList().run()} className={styleMenu.tipTapButton + " " + editor.isActive('bulletList') ? 'is-active' : ''}>
          <FormatListBulletedIcon></FormatListBulletedIcon>
        </Button>
        <Button color={editor.isActive('orderedList') ? "default" : "transparent"} onClick={() => editor.chain().focus().toggleOrderedList().run()} className={styleMenu.tipTapButton + " " + editor.isActive('orderedList') ? 'is-active' : ''}>
          <FormatListNumberedIcon></FormatListNumberedIcon>
        </Button>
        <Button color={editor.isActive('codeBlock') ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().toggleCodeBlock().run()} className={styleMenu.tipTapButton + " " + editor.isActive('codeBlock') ? 'is-active' : ''}>
          <CodeIcon></CodeIcon>
        </Button>
        <Button color={editor.isActive({ textAlign: 'left' }) ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().setTextAlign('left').run()} className={styleMenu.tipTapButton}>
          <FormatAlignLeftIcon></FormatAlignLeftIcon>
        </Button>
        <Button color={editor.isActive({ textAlign: 'center' }) ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().setTextAlign('center').run()} className={styleMenu.tipTapButton}>
          <FormatAlignCenterIcon></FormatAlignCenterIcon>
        </Button>
        <Button color={editor.isActive({ textAlign: 'right' }) ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().setTextAlign('right').run()} className={styleMenu.tipTapButton}>
          <FormatAlignRightIcon></FormatAlignRightIcon>
        </Button>
        <Button color={editor.isActive({ textAlign: 'justify' }) ? "default" : "transparent"} size="sm" onClick={() => editor.chain().focus().setTextAlign('justify').run()} className={styleMenu.tipTapButton}>
          <FormatAlignJustifyIcon></FormatAlignJustifyIcon>
        </Button>
        <Button color={"transparent"} size="sm" onClick={() => editor.chain().focus().toggleBlockquote().run()} className={styleMenu.tipTapButton + " " + editor.isActive('blockquote') ? 'is-active' : ''}>
          <CodeIcon></CodeIcon>
        </Button>
        <Button color={"transparent"} size="sm" onClick={() => editor.chain().focus().setHorizontalRule().run()}>
        <FormatTextdirectionLToRIcon></FormatTextdirectionLToRIcon>
        </Button>
        <Button color={"transparent"} size="sm" onClick={() => editor.chain().focus().setHardBreak().run()}>
          <AddIcon></AddIcon>
        </Button>
        <Button color={"transparent"} size="sm" onClick={() => editor.chain().focus().undo().run()}>
          <UndoIcon></UndoIcon>
        </Button>
        <Button color={"transparent"} size="sm" onClick={() => editor.chain().focus().redo().run()}>
          <RedoIcon></RedoIcon>
        </Button>
      </div>

  )


}

